import React from 'react';

import { cssMap } from '@atlaskit/css';
import VideoIcon from '@atlaskit/icon/core/video';
import { Box } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

const styles = cssMap({
	container: {
		alignItems: 'center',
		backgroundColor: token('color.background.neutral'),
		borderRadius: token('radius.medium'),
		display: 'flex',
		height: '100%',
		justifyContent: 'center',
		width: '100%',
	},
});

export const LoomVideoIcon = (): React.JSX.Element => (
	<Box testId="loom-video-icon" xcss={styles.container}>
		<VideoIcon label="" color={token('color.icon.brand')} />
	</Box>
);
